// extracted by mini-css-extract-plugin
export default {"LinkCard":"LinkCard_drDmB","LinkCard_background":"LinkCard_background_IM4KB","LinkCard_heading":"LinkCard_heading__Ps5O","LinkCard_media":"LinkCard_media_zhBaP"};